import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLogin:boolean = false;

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {
    this.authenticationService.isLoggedIn().subscribe(res => {
      console.log("res", res)
      this.isLogin = res;
     })
  }

  logout() {
    this.authenticationService.logOut();
    this.router.navigate(['/']);
  }

}
